// extracted by mini-css-extract-plugin
export default {"label_spec":"SecondaryDressing_label_spec__MfooE","warning":"SecondaryDressing_warning__KntWZ"};